import React from 'react';
import PropTypes from 'prop-types';
import { observer, inject } from 'mobx-react';
import styled from 'styled-components';
import _ from 'lodash';

import { Box } from 'grommet';
import {
  StatusCritical,
  StatusWarning,
  StatusGood,
  StatusInfo,
  StatusUnknown,
  StatusDisabled,
  Halt,
} from 'grommet-icons';

import HighlightedSentences from 'app/components/HighlightedSentences';

import ScrollIntoViewIfNeeded from 'react-scroll-into-view-if-needed';
const scrollIntoViewOptions = { behavior: 'instant', block: 'start' };

const icons = {
  critical: StatusCritical,
  warning: StatusWarning,
  ok: StatusGood,
  info: StatusInfo,
  unknown: StatusUnknown,
  disabled: StatusDisabled,
  halt: Halt,
};
const colors = {
  critical: 'light-1',
  warning: 'dark-1',
  ok: 'dark-1',
  info: 'light-1',
  unknown: 'dark-1',
  disabled: 'dark-1',
  halt: 'black',
};

const StyledBox = styled(Box)`
  box-shadow: 0px 2px 4px rgba(100, 100, 100, 0.5);
  @media (min-width: 600px) {
    width: 600px;
  }
`;

/** Callout component */
class Callout extends React.Component {
  render() {
    const { AppState, path, content } = this.props;
    const status = _.last(path);
    const StatusIcon = icons[status];
    const isNewSelection =
      !AppState.bookmarkingSelectionContent ||
      !content.includes(AppState.bookmarkingSelectionContent);
    return (
      <ScrollIntoViewIfNeeded
        options={scrollIntoViewOptions}
        active={_.isEqual(path, AppState.selectedSectionItem)}
      >
        <StyledBox
          aria-label="callout"
          align="center"
          background={`status-${status}`}
          direction="row"
          flex="grow"
          justify="start"
          margin={{ vertical: 'medium' }}
          gap="small"
          pad={{ horizontal: 'small' }}
          onClick={() => {
            AppState.isUserBookmarking &&
              AppState.setMenuBar('BOOKMARKING_MENU');
            const isBookmarking =
              AppState.isBookmarkingMenuBar || AppState.isUserAnnotating;
            if (isNewSelection && isBookmarking) {
              AppState.newBookmarkingSelection({ path, content: path });
            }
          }}
        >
          <StatusIcon color={colors[status]} />
          <div>
            <HighlightedSentences
              {...this.props}
              path={path}
              content={content}
              color={colors[status]}
            />
          </div>
        </StyledBox>
      </ScrollIntoViewIfNeeded>
    );
  }
}

Callout.propTypes = {
  /**
   * content path, determines callout type
   */
  path: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  ).isRequired,
  /**
   * message
   */
  content: PropTypes.string,
};
Callout.defaultProps = {
  content: ' ',
};

const Component = inject('AppState')(observer(Callout));
Component.displayName = 'Callout';
export const CalloutComponent = Callout;
export default Component;



// WEBPACK FOOTER //
// ./src/app/components/BookElements/Callout.js